<template>
    <div class="nav">
        <div class="head">
            <div class="name">
                <div class="oimg">
                    <img src="../assets/img/logo.png" alt />
                </div>
                <div class="spa">e博视智慧配电在线监测系统</div>
            </div>
            <div class="tatel">
                <div class="miti">
                    <!-- <i class="el-icon-warning"></i> -->
                </div>
                <div class="mixin">{{ title }}</div>
            </div>
        </div>
        <div style="width: 100%; height: 100%">
            <div class="diagram">
                <div class="fullbtn">
                    <div class="btn row-center" v-if="!isFull" @click="full">
                        <img src="@/assets/img/切换全屏ICON.png" style="margin-right:4rem" alt="切换全屏" />
                        <span>切换全屏</span>
                    </div>
                </div>
                <div class="content">
                    <div class="body">
                        <Diagram ref="Diagram" :src="currentWireURL" :isFull="isFull" @onCancelFull="onCancelFull">
                        </Diagram>
                    </div>
                </div>
                <!-- <div class="content-bg"></div> -->
            </div>
        </div>
    </div>
</template> 

<script>
    import Diagram from "@/components/Diagram";

    export default {
        name: "FirstDiagram",
        components: {
            Diagram,
        },
        data() {
            return {
                title: "一次图总览",
                  currentWireURL: "https://www.energydt.cn/wiring/ch/CHGZ.html",
                // currentWireURL: "http://local.vrmaker.vip:38080/wiring/lcy-1.html",

                isFull: false,
            };
        },
        computed: {},
        watch: {},
        created() {},
        mounted() {},
        beforeDestroy() {},

        
        methods: {
            full() {
                this.isFull = true;
                this.$refs.Diagram.full();
            },
            onCancelFull() {
                this.isFull = false;
            },
            cancelFull() {
                this.$refs.Diagram.cancelFull();
            },
        },
    };
</script>

<style lang="less" scoped>

    .head {
        width: 100%;
        height: 48rem;
        display: flex;
        margin-bottom: 24rem;

        .name {
            width: 440rem;
            height: 100%;
            background: #ffffff;
            display: flex;
            // padding: 12rem 17rem 0 24rem;
            justify-content: center;
            align-items: center;

            .spa {
                // width: 252rem;
                font-size: 26rem;
                font-weight: 400;
                color: #333333;
                margin-left: 17rem;
                font-weight: 400;
                // line-height: 44rem;
                font-family: "YouSheBiaoTiHei-2";
                text-align: center;
                // display: flex;
                // align-items: center;
            }

            .oimg {
                width: 24rem;
                height: 24rem;

                img {
                    width: 24rem;
                    height: 24rem;
                }
            }
        }

        .tatel {
            width: 560rem;
            height: 48rem;
            background: #ffffff;
            border: 1rem solid rgba(0, 0, 0, 0.01);
            padding: 12rem 0 12rem 24rem;
            box-shadow: 0rem 3rem 14rem 0rem rgba(3, 13, 24, 0.26);
            border-radius: 0rem 0rem 8rem 8rem;
            display: flex;
            align-items: center;
            text-align: center;

            .miti {
                width: 22rem;
                height: 22rem;

                i {
                    font-size: 22rem;
                    color: chocolate;
                }
            }

            .mixin {
                margin-left: 18rem;
                font-size: 24rem;
                font-weight: 400;
                margin-top: -2rem;
                // color: #cccccc;
                color: #666666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .diagram {
        // margin: auto;
    }

    .content {
        //   padding: 0 24rem;
        width: 1440rem;
        height: 930rem;
        display: flex;
        padding-left: 0;
        flex-direction: column;
        margin: auto;
        justify-content: space-between;
        align-items: center;
        // background-image: url(../assets/img/diagram-bg.png);
        background-repeat: no-repeat;
        background-size: 100%;

        .header {
            width: 1600rem;
            height: 96rem;
            background: #ffffff;
            box-shadow: 0rem 0rem 16rem 0rem rgba(0, 43, 102, 0.04);
        }
        .body {
            // margin: 35rem 0 0;
            width: 1440rem;
            height: 930rem;
            background: #eee;
            position: relative;
        }
        .pagination {
            height: 6vh;
            width: 300rem;
            align-self: flex-end;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            font-size: 14rem;

            .button {
                width: 74rem;
                height: 24rem;
                border: 1rem solid rgba(0, 0, 0, 0.15);
                border-radius: 2rem;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    .fullbtn {
        z-index: 9999;
        display: flex;

        // justify-content: center;
        // align-items: center;
        .btn {
            span {
                margin-top: -2rem;
            }

            width: 150rem;
            height: 56rem;
            position: absolute;
            top: 14rem;
            // right: 36rem;
            left: 1254rem;
            z-index: 9999;
            background-image: url(../assets/img/diagrambtn-bg.png);
            background-size: 100%;
            // text-align: center;
            // padding: 17rem;
            color: #333333;
            font-size: 14rem;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            // text-align: center;
            img {
                // .wh(16, 16);
                // width: @w;
                // height: @h;
                width: 16rem;
                height: 16rem;
                margin-right: 7 / 1920 * 100vw;
                margin-top: -2rem;
            }
        }
    }

    .content-bg {
        width: 1380rem;
        height: 49rem;
        background-image: url(../assets/img/倒影.png);
        margin: auto;
    }

    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>